/**
 * Created by lenovo on 2017/2/20.
 */
const en_US = {
    'email': 'email',
    'password': 'password',

    //ella
    'PermissionManagement':'Permission Management',
    'Subsystem':'Subsystem',
    'SubsystemList':'Subsyste List',
    'AddSubsystem':'Add Subsystem',
    'EditSubsystem':'Edit Subsystem',
    'DetailSubsystem':'Detail Subsystem',
    'SubsystemName':'Subsystem Name',
    'SubsystemNumber':'Subsystem Number',
    'AccessPath':'Access Path',
    userTypeName : 'userType Name',
    userType:'userType',
    extendedCoding : 'extended Attribute Coding',
    extendedName :'extended Attribute Name',
    defaultAttributeValue:'default Attribute Value',
    sendTime : 'Send time',
    systemType : 'System type',
    systemName : 'System Name',
    versionNumber:'version Number',
    versionTime : 'version time',
    download : 'download',


    StatisticalManagement:'Statistical Management',
    UserDistributionStatistics:'User Distribution Statistics',
    UserInformationStatistics:'User Information Statistics',

    StatisticsTime:'Statistics Time',



    ProtocolParameter:'Protocol Parameter',
    ProtocolParameterList:'Protocol Parameter List',

    CreatePermissions:'Create Permissions',
    CreateModel:'Create Model',
    level:'level',
    subsystem:'subsystem',

    deviceManagement:'device Management',
    DeviceOnlineInquiry:'Device Online Inquiry',
    queryCriteria:'query Criteria',
    TermOfValidity:'Term of validity',


    //bump
    proAdd : 'protocol Add',
    proEdit:'protocol Edit',
    proName : 'protocol Name',
    ModelCategory : 'Model category',
    proHead : 'protoco Head',
    protocoFoot : 'protoco Foot',
    proCheckName:'protoco Check Name',
    proCheckStart:'protoco Check Start',
    proCheckEnd:'protoco Check End',
    proDefinition:'Protocol definition',
    ProtocolParameterAdd:'ProtocolParameter Add',
    ProtocolParameterEdit:'ProtocolParameter Edit',
    CategoryName : 'Category Name',
    codePre:'codePre',
    pframework:'pframework',
    meta:'meta',
    paramCode:'paramCode',
    paramName:'paramName',
    paramNameEn : 'paramNameEn',
    anvalue:'andvalue',
    targetMeta : 'targetMeta',

    anCode:'anCode',
    anName :'anName',
    anValue :'anValue',
    metaNames:'metaNames',
    isSaveHis:'isSaveHis',
    hisMsgType:'hisMsgType',


    organizationStructure:'organization Structure',
    CreateOrganizationalStructures:'Create Organizational Structures',
    Yes:'Yes',
    No:'No',
    CommandAnalysis:'Command Analysis',
    CommandAnalysisList:'Command Analysis List',
    CommandAnalysisAdd:'Command Analysis Add',
    CommandAnalysisEdit:'Command Analysis Edit',
    ModelCreation:'Model Creation',
    APPManagement:'APP Management',
    APPVersionsList:'APP Versions List',
    APPVersionsAdd:'APP Versions Add',
    APPVersionsEdit:'APPVer sions Edit',
    managersList:'managers List',
    managersAdd:'managers Add',
    managersEdit:'managers Edit',
    managersDetail:'managers Detail',
    extended:'extended',
    managers:'managers',

    userTypeList : 'user Type List',
    userTypeAdd : 'userType Add',
    userTypeEdit : 'userType Edit',

    // common
    fullName:'full Name',
    IncompleteInformation:'Incomplete Information！',
    AuthorityAssignment:'Authority Assignment',
    'role':'role',
    'oldPass':'old password',
    'newPass':'new password',
    'passAgain':'password again',
    'pleaseSelect':'please select',
    "time": "time",
    "searchCondition": "Search Condition",
    "configuration": "Configuration",
    "info": "Information",
    "query": "Query",
    "view": "View",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "resetPassword":"ResetPassword",
    'readyDelete': 'Are You Ready To Delete?',
    'deleteNode': 'Are you sure you want to delete nodes',
    "more": "More",
    "remark": "Remark",
    "operation": "Operation",
    "background": "Background",
    "manage": "Manage",
    "apply": "Apply",
    "submit": "Submit",
    "return": "Return",
    "success": "Success",
    "failure": "Failure",
    "save": "Save",
    "unit": "dollar",
    "detail": "Detail",
    "contacts": "contacts",
    "name": "Name",
    "telephone": "Telephone",
    "createTime": "Create Time",
    "status": "Status",
    "address": "Address",
    "addressDetail":"AddressDetail",
    "operate": "Operate",
    "directSales": "directSales",
    "disable": "disable",
    "stop":'stop',
    "enable": "enable",
    "freeze": "Freeze",
    "unfreeze": "Unfreeze",
    "readyStop":"Are You Ready To Stop?",
    "readyDisable": "Are You Ready To Disable?",
    "readyEnable": "Are You Ready To Enable?",
    "readyFreeze": "Are You Ready To Freeze?",
    "readyUnfreeze": "Are You Ready To Unfreeze?",
    "noneData": "none data",
    "no": "No",
    "IDCardNo": "IDCardNo",
    "invitationCode": "Invitation Code",
    "close": "Close",
    "sure": "Sure",
    "export": "Export",
    'noDataText': 'There is no data to display',
    'firstPage': 'firstPage',
    'lastPage': 'lastPage',
    'valid': 'valid',
    'invalid': 'invalid',
    'prompt':'prompt',
    "resetting":"Reset",
    "contactTelephone": "Contact Telephone",
    "loginName":"LoginName",
    "systemConfirm":"System Confirm",
    "AreYouSureDoThis":"Are you sure do this?",

    // dealer服务商
    'mchName':'mchName',
    "operatorName":"operatorName",
    'handleUser': 'handle User',
    'store': "Store",
    'check': "Check",
    'list': "List",
    "recheck": "Recheck",
    "store_xx_info": "Store Check Info",
    "user_type": "User Type",
    "dealer": "Dealer",
    "service": "SERVICE",
    "rewardCode": "Reward Code",
    "finishRewardCondition": "Finish Reward Condition",
    "reward": "reward",
    "type": "Type",
    "form": "Form",
    "order": "Order",
    "business_amount": "Business Amount",
    "withdraw_deposit_flow_detail": "Withdraw Deposit Flow Detail",
    "subordinate_name": "DealerName",
    "flow_no": "Flow No",
    "business_no": "Business_no",
    "account": "Account",
    "flow": "Flow",
    "business_type": "BusinessType",
    "bank_name": "BankName",
    "bank_card_no": "BankCard No",
    "bank_card": "BankCard",
    "opening_bank": "opening bank",
    "available_balance": "Available Balance",

    // lease 租赁
    'returnUserDetail':'Return User Detail',
    "activityList": "Activity List",
    "activityRuleList": "Activity Rule List",
    'activityDetail':'Activity Detail',
    "activityManage": "Activity Manage",
    "activityName": "Activity Name",
    "activityCode": "Activity Code",
    'activityTime':'Activity Time',
    "activityState": "Activity State",
    "activityRuleName": "Activity Rule Name",
    "activityRuleCode": "Activity Rule Code",
    "activityRuleState": "Activity Rule State",
    'addActivity': 'Add Activity',
    'editActivity': 'Edit Activity',
    'addActivityRule': 'Add Activity Rule',
    'editActivityRule': 'Edit Activity Rule',
    'couponList': 'Coupon List',
    'rewardActivity':'reward activity',
    'activityType':'Activity Type',
    'rewardType':'Reward Type',
    'orderManage': 'Order Manage',
    'orderSearch': 'Order Search',

    'staffManagement': 'Staff Management',
    'staffAccountManage': 'Staff Account Management',
    'staffAccountList': "Staff Account List",
    'staffAdd':'Staff Add',
    'staffEdit':'Staff Edit',
    'roleManagement': 'Role Management',
    'roleList': 'role list',
    'roleName': 'role name',
    'roleNo':'Rolw No',
    'addRole': 'add role',
    'editRole': 'edit role',
    'roleDetail': 'role detail',
    'billingScheme': 'Billing scheme',

    'systemSettings': 'System Settings',
    'publicSettings': "Public Settings",
    'addPlan': 'add a billing plan',
    'editPlan': 'edit a billing plan',
    'addDetailPlan': 'add a detail billing plan',
    'editDetailPlan': 'edit a detail billing plan',
    'planName': 'plan name',

    'userFeedback': 'user feedback',
    'setFeedback': 'Set the feedback problems',
    'addFeedback': 'Add feedback problems',
    'editFeedback': 'Edit feedback problems',
    'feedbackList': 'feedbackList',

    'EditIntergralAccount':'Edit Wallet account open platform ',
    'AddIntergralAccount':'Add Wallet account open platform ',

    'OperatorsIntegral':'Operators Integral configuration',

    'fundsManagement': 'Funds Management',
    'configAccount': 'The configuration of the dealer credit accounts',
    'EditAlipayAccount': 'Edit alipay payment account ',
    'AddAlipayAccount': 'Add alipay payment account ',
    'DtailAlipayAccount': ' Alipay payment account detail',
    'AddWeChatPublicAccounts': 'Add WeChat accounts of public platform ',
    'EditWeChatPublicAccounts': 'Edit WeChat accounts of public platform ',
    'EditWeChatOpenAccount': 'Edit WeChat account open platform ',
    'AddWeChatOpenAccount': 'Add WeChat account open platform ',

    "operatorStatus": "operatorStatus",
    "gmtStart": 'begin time',
    'gmtEnd': 'end time',
    "vendorManage": "vendorManage",
    "operator": "Operator",
    "addOperator": "Add Operator",
    "openAccountTime": "OpenAccountTime",
    "agent": "Agent",
    "userManage": "UserManage",
    "userList": "User List",
    "normalUser": "NormalUser",
    "normalUserList": "NormalUser List",
    "normalUserAdd":"normalUser Add",
    "normalUserEdit":"normalUser Edit",
    "normalUserDetail":"normalUser Detail",
    "userDetail": "UserDetail",
    "user": "User",
    "addAgent": "Add Agent",
    "addDealer": "Add Dealer",
    "addRegion": "Add Region",
    "region":"Region",
    "queryRegion":"Query Region",
     "regionEdit":"Edit Region",
    "regionManage": "Region Manage",
    "regionList": "Region List",
    "regionName": "Region Name",
    "regionNo": "RegionNo",
    "chargeCase": "ChargeCase",
    "hasParking": "has parking",
    "hasnotParking": "has not parking",
    "regionInfoManage": "Region Info Manage",
    "regionManage":"Region Manage",
    "regionInfo": "Region Info",
    "regionAdd":"Region Add",
    "regionEdit":"Region Edit",
    "regionCode": "Region Code",
    "parkingManage": "Parking Manage",
    "parkingList": "Parking List",
    "addParking": "Add Parking",
    "parkingName": "Parking Name",
    "parkingNameAndCodeAndId":" ParkingName/parkingCode/ID",
    "carNum": "Car Number",
    "maxCarNum": "Max Car Number",
    "parkingInfoManage": "Parking Info Manage",
    "parkingInfo": "Parking Info",
    "parkingInfoAdd": "Parking Info Add",
    "parkingInfoEdit": "Parking Info Edit",
    "parkingInfoDetail": "Parking Info Detail",
    "parkingCode": "Parking Code",
    "agreeMore": "Agree More",
    "notAgreeMore": "Not Agree More",
    "registerTime": "Register Time",
    "deposit": "Deposit Money",
    "depositState":"Deposit State",
    "point": "Point",
    "walletBalance": "Wallet Balance",
    "depositBalance": "Deposit Balance",
    "userAccount": "User Account",
    "queryOrder": "Query Order Record",
    "queryDeposit": "Query Deposit Record",
    "queryWallet": "Query Wallet Record",
    "queryCoupon": "Query Coupon Record",
    "accountStatus": "Account Status",
    "disableAccount": "Disable Account",
    "enableAccount": "Enable Account",
    "freezeFundAccount": "FreezeFundAccount",
    "unfreezeFundAccount": "UnfreezeFundAccount",
    "carNo": "carNo",
    "rentCarTime": "rentCarTime",
    "charge": "Charge",
    "orderStatus": "Order Status",
    "payStatus": "Pay Status",
    "orderNo": "OrderNo",
    "unread": "unread",
    "read": "read",
    "fundFlow": "Fund Flow",
    "depositRecord": "Deposit Record",
    "depositRecordList": "Deposit Record List",
    "depositRecordDeatil": "Deposit Record Detail",
    "payType": "payType",
    "businessTime": "BusinessTime",
    "actTime": "actType",
    "payChannel":'payChannel',
    "depositRecharge": "Deposit Recharge(dollar)",
    "depositWithdraw": "Deposit Withdraw(dollar)",
    "depositIncome": "Deposit Income(dollar)",
    "depositRechargeTime": "DepositRechargeTime",
    "realName": "RealName",
    "businessStatus": "Business Status",
    "businessFlowNo": "BusinessFlowNo",
    "businessOrderNo": "BusinessOrderNo",
    "businessName": "BusinessName",
    "thirdBusinessPayAccount": "Third Business Pay Account",
    "amount": "Amount",
    "businessAmountType": "BusinessAmountType",
    "traderMoneyBefore": "TraderMoneyBefore(dollar)",
    "traderMoneyAfter": "TraderMoneyAfter(dollar)",
    'refundNo': 'refundNo',
    "refundAmount": "refundAmount(dollar)",
    "refundReason": "refundReason",
    "rewardAmount": "rewardAmount(dollar)",
    "flowCreateTime": "FlowCreateTime",
    "tradeTime": "TradeTime",
    "refundTime": "RefundTime",
    "depositRecharge1": "DepositRecharge",
    "depositWithdraw1": "DepositWithdraw",
    "walletRecord": "WalletRecord",
    "walletRecordList": "WalletRecordList",
    "walletRecordDetail":"wallet Record Detail",
    "withdrawType": "WithdrawType",
    "walletRecharge": "WalletRecharge(dollar)",
    "walletWithdraw": "WalletWithdraw(dollar)",
    "walletRecharge1": "WalletRecharge",
    "walletWithdraw1": "WalletWithdraw",
    "walletIncome": "walletIncome(dollar)",
    "walletRechargeTime": "WalletRechargeTime",
    "dblclickToDetail": "Dblclick To Detail",
    "tradeFinishTime": "Trade Finish Time",
    "pointWithdraw": "PointWithdraw",
    "applyTransferAmount": "Apply Transfer Amount(dollar)",
    "actualTransferAmount": "Actual Transfer Amount(dollar)",
    "receiverAccount": "Receiver Account",
    "receiverRealName": "Receiver Real Name",
    "tradeCreateTime": "Trade Create Time",
    "transferResult": "Transfer Result",
    "pointRecharge": "Point Recharge",
    "businessType": "BusinessType",
    "belongDealer": "BelongDealer",
    "belongAgent":"BelongAgent",
    'businessInfo': 'Business information',
    'basicInfo': 'Basic information',
    "belongOperator": "BelongOperator",
    "regionNameAndId": "regionName/Id",
    'OperatorsAlipay': 'Operators Alipay configuration',
    'OperatorsWxpay': 'Operators Wxpay configuration',
    'belongRegion':'BelongRegion',
    'userTelephone':'User Telephone',
    'settleCase':'SettleCase',
    "recovery":"recovery",
    "settle":"Settle",
    "agentName":"AgentName",
    'dealerName':'DealerName',
    'belongParking':'Belong Parking',
    'carStatus':'Car Status',


    appIdPublic : 'WeChat public appid',
    appIdOpen : 'Account appid WeChat open platform',
    mchIdWx:'WeChat MchId',
    mchName :'mchName',
    subKey : 'subKey',
    apiKey:'WeChat signature verification key',
    certNo :'certNo',
    certExpired :'WeChat merchants certificate expiration time',
    cert : 'Certificate of WeChat merchants',
    "caseName":"CaseName"
};
export default en_US;



// WEBPACK FOOTER //
// ./modules/utils/en_US.js